import { useState, useEffect } from "react";
import { addRemittanceNote, getRemittanceNoteHistory } from "../api";
import { toast } from "react-toastify";

const useNoteForm = ({ remittanceNoteId, closeModal, onSuccess }) => {
  const [note, setNote] = useState("");
  const [noteHistory, setNoteHistory] = useState(null);

  useEffect(() => {
    if (remittanceNoteId) {
      fetchNoteHistory();
    }
    //eslint-disable-next-line
  }, [remittanceNoteId]);

  const fetchNoteHistory = async () => {
    const res = await getRemittanceNoteHistory(remittanceNoteId);
    if (res?.success) {
      setNoteHistory(res);
    }
  };

  const handleSubmitNote = () => {
    if (!note?.trim()) {
      toast.error("Note is required");
      return;
    }

    const obj = {
      remittance_id: remittanceNoteId,
      note: note,
    };

    addRemittanceNote(obj).then((res) => {
      if (res?.success) {
        toast.success("Note added successfully");
        setNote("");
        onSuccess?.();
        closeModal();
      } else {
        toast.error(res?.message || "Failed to add note");
      }
    });
  };

  return { note, noteHistory, handleSubmitNote, setNote };
};

export default useNoteForm;
